import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { PageHeader, SecretsTabs, errMsg, fmtDate } from './common';

const ROLE_HELP = {
  viewer: 'Sees everything, including raw-key search. Cannot change anything.',
  editor: 'Can also change key status, revokers, Jira cards, notes, teams and repo sign-offs.',
};

export default function SecretsSharing() {
  const [d, setD] = useState(null);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('viewer');
  const [note, setNote] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(() => {
    axios.get('/secrets/access').then((r) => setD(r.data)).catch((e) => setError(errMsg(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const put = (em, rl, nt) => axios.put(`/secrets/access/${encodeURIComponent(em)}`, { role: rl, note: nt || undefined });

  const add = (e) => {
    e.preventDefault();
    const em = email.trim().toLowerCase();
    if (!em) return;
    setMsg('');
    put(em, role, note)
      .then(() => { setMsg(`Shared with ${em} as ${role}.`); setEmail(''); setNote(''); load(); })
      .catch((err) => setMsg(errMsg(err)));
  };
  const remove = (em) => {
    if (!window.confirm(`Stop sharing the tracker with ${em}?`)) return;
    axios.delete(`/secrets/access/${encodeURIComponent(em)}`).then(load).catch((err) => setMsg(errMsg(err)));
  };

  return (
    <div>
      <PageHeader title="Secrets rotation · Sharing">
        Choose who else can open this tracker. They sign in with their own Google account; the email must match it.
        Changes take effect on their next page load and are recorded in Activity.
      </PageHeader>
      <div className="page-body">
        <SecretsTabs />
        {error && <div className="error-msg">{error}</div>}
        <div className="card" style={{ marginBottom: 16 }}>
          <form onSubmit={add} style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div style={{ width: 280 }}>
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={email} placeholder="name@exotel.com"
                onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div style={{ width: 140 }}>
              <label className="form-label">Access</label>
              <select className="form-input" value={role} onChange={(e) => setRole(e.target.value)}>
                <option value="viewer">Viewer</option>
                <option value="editor">Editor</option>
              </select>
            </div>
            <div style={{ width: 240 }}>
              <label className="form-label">Note</label>
              <input className="form-input" value={note} placeholder="Optional, e.g. Infra revoker"
                onChange={(e) => setNote(e.target.value)} />
            </div>
            <button className="btn btn-primary" disabled={!email.trim()}>Share</button>
          </form>
          <div style={{ marginTop: 10, fontSize: 12, color: 'var(--text-muted)' }}>{ROLE_HELP[role]}</div>
          {msg && <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text-secondary)' }}>{msg}</div>}
        </div>

        <div className="table-wrap">
          <table>
            <thead><tr><th>Email</th><th>Access</th><th>Note</th><th>Added</th><th /></tr></thead>
            <tbody>
              {d && (
                <tr>
                  <td>{d.owner}</td>
                  <td><span className="badge badge-medium">Owner</span></td>
                  <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>Always has access</td>
                  <td />
                  <td />
                </tr>
              )}
              {(d?.data || []).map((a) => (
                <tr key={a.email}>
                  <td>{a.email}</td>
                  <td>
                    <select className="form-input" style={{ width: 120 }} value={a.role}
                      onChange={(e) => put(a.email, e.target.value).then(load).catch((err) => setMsg(errMsg(err)))}>
                      <option value="viewer">Viewer</option>
                      <option value="editor">Editor</option>
                    </select>
                  </td>
                  <td style={{ fontSize: 12 }}>{a.note}</td>
                  <td style={{ fontSize: 12 }}>{fmtDate(a.created_at)}<div style={{ color: 'var(--text-muted)' }}>by {a.added_by}</div></td>
                  <td><button className="btn btn-ghost" onClick={() => remove(a.email)}>Remove</button></td>
                </tr>
              ))}
              {d && !d.data.length && (
                <tr><td colSpan={5} style={{ color: 'var(--text-muted)', padding: 16 }}>Not shared with anyone yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
